module.exports = __webpack_public_path__ + "img/share_box.660b1a48.png";